import { createIcon } from '@chakra-ui/react'

export const GridIcon = createIcon({
  displayName: 'GridIcon',
  path: (
    <path
      fill='currentColor'
      d='M80 80v96h96V80H80zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zm48 256v96h96v-96H80zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-96zM432 80h-96v96h96V80zm-96-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 304v96h96v-96h-96zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-96z'
    />
  ),
  viewBox: '0 0 512 512',
})
